import React, { useState, useEffect, useRef } from 'react';
import { Calendar, CheckCircle, Search, ChevronDown, ChevronUp, Info, X , IndianRupee} from 'lucide-react';
import { API_BASE_URL, INSPECTION_IMAGE_BASE_URL } from '../services/api';
import PhotoCapture from '../components/PhotoLocation';
import { useSearchParams } from 'react-router-dom';
const InspectionForm = () => {
    const [searchParams] = useSearchParams();
  const [formData, setFormData] = useState({
    inspectionDate: new Date().toISOString().split('T')[0],
    housingId: '',
    beneficiaryName: '',
    mobile: '',
    district: '',
    block: '',
    panchayat: '',
materialProvided: '',
    scheme: '',
    aadhar: '',
    stageOfConstruction: '',

    additionalRemarks: '',
    constructionOngoing: '',
reasonNotOngoing: '',

otherReason: '',
paymentReceived: '',
  totalAmountReceived: '',
  confirmNoAmountAtFinalStage: false,
 go50Received: '', // For GO 50 bandalmann housing basement
  houseSize: '', // Size of house (basement level only)
  mgnregsReceived: '', // MGNREGS 90 days employment
financingSource: [], // Source of financing (multiple selection)
  otherFinancingSource: '', // When "others" is selected
  helpNeeded: '', // Any ot
  cementReceived: '',
steelReceived: '',
mgnregsDaysReceived: '',
toiletConstructed: '',
  });
const [housingOptions, setHousingOptions] = useState([]);
const [blockOptions, setBlockOptions] = useState([]);
const [panchayatOptions, setPanchayatOptions] = useState([]);
const [nameOptions, setNameOptions] = useState([]);
const [houseData, setHouseData] = useState(null);
const [blockSearch, setBlockSearch] = useState('');
const [panchayatSearch, setPanchayatSearch] = useState('');
const [nameSearch, setNameSearch] = useState('');
const [showBlockDropdown, setShowBlockDropdown] = useState(false);
const [showPanchayatDropdown, setShowPanchayatDropdown] = useState(false);
const [showNameDropdown, setShowNameDropdown] = useState(false);
const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [savingDraft, setSavingDraft] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [previousPayments, setPreviousPayments] = useState([]);
const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [photoData, setPhotoData] = useState([]);
const [resetPhotoTrigger, setResetPhotoTrigger] = useState(0);
const blockDropdownRef = useRef(null);
const [fieldErrors, setFieldErrors] = useState({});
const [schemeDetails, setSchemeDetails] = useState(null);
const [draftInspectionId, setDraftInspectionId] = useState(null);
const panchayatDropdownRef = useRef(null);
const nameDropdownRef = useRef(null);
  // Fetch panchayats on component mount
// Fetch blocks on component mount
useEffect(() => {
  fetchBlocks();
  
  // Check if there's a houseId parameter in the URL
  const houseIdFromUrl = searchParams.get('houseId');
  if (houseIdFromUrl) {
    // Set the housing ID in the form
    setFormData(prev => ({ ...prev, housingId: houseIdFromUrl }));
    // Search for this housing ID to get the full details
    searchHousingIds(houseIdFromUrl);
  }
}, [searchParams]);
// Auto-select house when coming from notification
useEffect(() => {
  const houseIdFromUrl = searchParams.get('houseId');
  if (houseIdFromUrl && housingOptions.length > 0) {
    // Find the matching house in the search results
    const matchingHouse = housingOptions.find(house => house.h_id === houseIdFromUrl);
    if (matchingHouse) {
      handleHousingIdChange(matchingHouse);
    }
  }
}, [housingOptions, searchParams]);

  const financingSources = [
  'Jewellery loan',
  'Savings', 
  'Friends loan',
  'Others',
  'No funds'
];

const mgnregsOptions = [
  'Yes',
  'No', 
  'Not known'
];


const reasonsNotOngoing = [
  'Labour non-availability',
  'Construction material not available', 
  'Not enough funds',
  'Personal issues',
  'Beneficiary migrated/not in town',
  'Land dispute',
  'Death of houseowner',
  'Others'
];

const getCurrentStage = () => {
  if (!houseData || !houseData.stage) {
    return null;
  }
  
  console.log('Current stage detected:', houseData.stage); // Debug log
  
  return houseData.stage;
};

// Helper function to get payment amount for current stage


const formatMaterialString = (materials) => {
  if (!materials) return '';
  const parts = [];
  if (materials.cement) parts.push(`${materials.cement} bags cement`);
  if (materials.steel) parts.push(`${materials.steel}kg steel`);
  return parts.join(' and ');
};
const getAvailableStages = () => {
  if (!schemeDetails?.detail) return [];
  
  // If no house data or stage, show all stages
  if (!houseData?.stage) {
    return schemeDetails.detail.map(stage => stage.name);
  }
  
  const currentStage = houseData.stage;
  const allStages = schemeDetails.detail.map(stage => stage.name);
  
  // Find the index of current stage in the scheme stages
  const currentIndex = allStages.findIndex(stage => 
    stage.toLowerCase().trim() === currentStage.toLowerCase().trim()
  );
  
  // If current stage found, return stages from current stage onwards
  if (currentIndex !== -1) {
    return allStages.slice(currentIndex);
  }
  
  // If current stage not found, show all stages
  return allStages;
};
// Check if question was already answered "yes" for current stage

// Check if payment was received for this specific stage

const fetchBlocks = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/project/blocks`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();
    if (response.ok && data.data) {
      setBlockOptions(data.data);
    } else {
      setBlockOptions([]);
    }
  } catch (err) {
    console.error('Error fetching blocks:', err);
    setBlockOptions([]);
  }
};

// Fetch panchayats based on selected block
const fetchPanchayats = async (blockName) => {
  if (!blockName) {
    setPanchayatOptions([]);
    return;
  }

  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/project/${blockName}/panchayats`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();
    if (response.ok && data.data) {
      setPanchayatOptions(data.data);
    } else {
      setPanchayatOptions([]);
    }
  } catch (err) {
    console.error('Error fetching panchayats:', err);
    setPanchayatOptions([]);
  }
};

  // Fetch beneficiaries based on selected panchayat
  const fetchBeneficiaries = async (panchayatName) => {
    if (!panchayatName) {
      setNameOptions([]);
      return;
    }

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/project/house/${panchayatName}/beneficiaries`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (response.ok && data.data) {
        setNameOptions(data.data);
      } else {
        setNameOptions([]);
      }
    } catch (err) {
      console.error('Error fetching beneficiaries:', err);
      setNameOptions([]);
    }
  };

  // Fetch housing IDs when user types
  const searchHousingIds = async (searchTerm) => {
    if (!searchTerm || searchTerm.length < 2) {
      setHousingOptions([]);
      return;
    }
    
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/project/house/id-search/${searchTerm}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (response.ok && data.data && data.data.length > 0) {
        setHousingOptions(data.data);
      } else {
        setHousingOptions([]);
      }
    } catch (err) {
      setHousingOptions([]);
    } finally {
      setLoading(false);
    }
  };

// Add new function to fetch scheme details
// Add new function to fetch scheme details
const fetchSchemeDetails = async (schemeName) => {
  if (!schemeName) return null;
  
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/master/scheme/${schemeName}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();
    if (response.ok && data.data) {
      console.log('Scheme details loaded:', data.data);
      return data.data;
    } else {
      console.error('Failed to fetch scheme details:', data.message || 'No scheme data found');
      return null;
    }
  } catch (err) {
    console.error('Error fetching scheme details:', err);
    return null;
  }
};

const fetchProjectDetails = async (houseId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await fetch(`${API_BASE_URL}/project/detail/${houseId}`, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      }
    });

    const data = await response.json();

    if (response.ok && data.data) {
      const projectData = data.data;
      const allInspections = Array.isArray(projectData.inspection)
        ? projectData.inspection.filter(Boolean)
        : [];

      // Historical rows without workflow_status are treated as submitted.
      const submittedInspections = allInspections.filter(inspection =>
        (inspection.workflow_status || 'Submitted') !== 'Draft'
      );

      let localUser = {};
      try {
        localUser = JSON.parse(localStorage.getItem('user') || '{}');
      } catch {
        localUser = {};
      }

      const currentUserId = Number(data.user?.id || localUser.id || 0);

      const ownDraft = allInspections.find(inspection =>
        inspection.workflow_status === 'Draft' &&
        Number(inspection.created_by) === currentUserId
      );

      setDraftInspectionId(ownDraft?.id || null);

      const masterValues = {
        housingId: projectData.h_id || '',
        beneficiaryName: projectData.beneficiary || '',
        mobile: projectData.mobile || '',
        district: projectData.district || '',
        block: projectData.block || '',
        panchayat: projectData.panchayat || '',
        scheme: projectData.scheme || '',
        aadhar: projectData.aadhar || ''
      };

     if (ownDraft?.draft_form) {
  setFormData(prev => ({
    ...prev,
    ...ownDraft.draft_form,
    ...masterValues,
    inspectionDate: String(
      ownDraft.inspect ||
      ownDraft.inspected ||
      ownDraft.draft_form.inspectionDate ||
      prev.inspectionDate ||
      ''
    ).split('T')[0]
  }));

        const restoredPhotos = (Array.isArray(ownDraft.images) ? ownDraft.images : [])
          .filter(Boolean)
          .map((path, index) => ({
            id: `draft-${ownDraft.id}-${index}`,
            path,
            url: `${INSPECTION_IMAGE_BASE_URL}/${String(path).replace(/^\/+/, '')}`
          }));

        setPhotoData(restoredPhotos);
        setSuccess('Saved draft loaded. You can continue the inspection.');
      } else {
        // Fresh house: do not carry values from another house/draft.
        setFormData(prev => ({
          inspectionDate: new Date().toISOString().split('T')[0],
          housingId: masterValues.housingId,
          beneficiaryName: masterValues.beneficiaryName,
          mobile: masterValues.mobile,
          district: masterValues.district,
          block: masterValues.block,
          panchayat: masterValues.panchayat,
          materialProvided: '',
          scheme: masterValues.scheme,
          aadhar: masterValues.aadhar,
          stageOfConstruction: '',
          additionalRemarks: '',
          constructionOngoing: '',
          reasonNotOngoing: '',
          otherReason: '',
          paymentReceived: '',
          totalAmountReceived: '',
          confirmNoAmountAtFinalStage: false,
          go50Received: '',
          houseSize: '',
          mgnregsReceived: '',
          financingSource: [],
          otherFinancingSource: '',
          helpNeeded: '',
          cementReceived: '',
          steelReceived: '',
          mgnregsDaysReceived: '',
          toiletConstructed: '',
          ...Object.keys(prev).reduce((acc, key) => {
            if (
              key.includes('materialProvided_') ||
              key.includes('cementReceived_') ||
              key.includes('steelReceived_') ||
              key.includes('mgnregsReceived_') ||
              key.includes('mgnregsDaysReceived_')
            ) {
              acc[key] = '';
            }
            return acc;
          }, {})
        }));

        setPhotoData([]);
        setSuccess('');
      }

      setBlockSearch(projectData.block || '');
      setPanchayatSearch(projectData.panchayat || '');
      setNameSearch(projectData.beneficiary || '');

      if (projectData.block) {
        await fetchPanchayats(projectData.block);
      }
      if (projectData.panchayat) {
        await fetchBeneficiaries(projectData.panchayat);
      }

      if (projectData.payments) {
        setPreviousPayments(projectData.payments);
      }

      if (projectData.scheme) {
        const loadedSchemeDetails = await fetchSchemeDetails(projectData.scheme);
        if (loadedSchemeDetails) {
          setSchemeDetails(loadedSchemeDetails);
        }
      }

      // Draft rows must not appear under Recent Inspections.
      setHouseData({
        ...projectData,
        inspection: submittedInspections
      });

      console.log('Project details loaded:', projectData);
      if (ownDraft) {
        console.log('Own draft restored:', ownDraft.id);
      }
    } else {
      console.error('Failed to fetch project details:', data.message || 'No data found');
    }
  } catch (err) {
    console.error('Error fetching project details:', err);
  }
};

const handleHousingIdChange = (selectedHouse) => {
  setFormData(prev => ({
    ...prev,
    housingId: selectedHouse.h_id,
    beneficiaryName: selectedHouse.beneficiary,
    mobile: selectedHouse.mobile
  }));
  
  setHousingOptions([]);
  fetchProjectDetails(selectedHouse.id);
};


  const handleSearchChange = (value) => {
    setFormData(prev => ({ 
      ...prev, 
      housingId: value,
      beneficiaryName: '',
      mobile: ''
    }));
    setHouseData(null);
    setDraftInspectionId(null);
    setPhotoData([]);
    setSuccess('');
    searchHousingIds(value);
  };

  const handlePhotoChange = (photos) => {
    setPhotoData(photos);
  };

  const handleInputChange = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };
// Filter functions for searchable dropdowns
// Filter functions for searchable dropdowns
const filteredBlocks = blockOptions.filter(block =>
  (block.name || block).toLowerCase().includes(blockSearch.toLowerCase())
);

const filteredPanchayats = panchayatOptions.filter(panchayat =>
  (panchayat.name || panchayat).toLowerCase().includes(panchayatSearch.toLowerCase())
);

// Handle block selection
const handleBlockSelect = (block) => {
  const blockName = block.name || block;
  handleInputChange('block', blockName);
  setBlockSearch(blockName);
  setShowBlockDropdown(false);
  
  // Reset panchayat and name selection
  handleInputChange('panchayat', '');
  handleInputChange('beneficiaryName', '');
  setPanchayatSearch('');
  setNameSearch('');
  fetchPanchayats(blockName);
};
const filteredNames = nameOptions.filter(name =>
  (name.name || name.beneficiary || name).toLowerCase().includes(nameSearch.toLowerCase())
);

// Handle panchayat selection
// Handle panchayat selection
const handlePanchayatSelect = (panchayat) => {
  const panchayatName = panchayat.name || panchayat;
  handleInputChange('panchayat', panchayatName);
  setPanchayatSearch(panchayatName);
  setShowPanchayatDropdown(false);
  
  // Reset name selection and fetch new beneficiaries
  handleInputChange('beneficiaryName', '');
  setNameSearch('');
  fetchBeneficiaries(panchayatName);
};

// Handle name selection// Handle name selection
const handleNameSelect = async (name) => {
  const beneficiaryName = name.name || name.beneficiary || name;
  const housingId = name.h_id;
  
  // Update form data immediately
  setFormData(prev => ({
    ...prev,
    beneficiaryName: beneficiaryName,
    housingId: housingId
  }));
  
  setNameSearch(beneficiaryName);
  setShowNameDropdown(false);
  
  // Search for the housing ID to get full details
  if (housingId) {
    try {
      setLoading(true);
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/project/house/id-search/${housingId}`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      const data = await response.json();
      if (response.ok && data.data && data.data.length > 0) {
        // Find the exact match
        const exactMatch = data.data.find(house => house.h_id === housingId);
        if (exactMatch) {
          // Update form with housing details
          setFormData(prev => ({
            ...prev,
            housingId: exactMatch.h_id,
            beneficiaryName: exactMatch.beneficiary,
            mobile: exactMatch.mobile
          }));
          
          // Fetch full project details which will auto-populate dropdowns
          await fetchProjectDetails(exactMatch.id);
        }
      }
    } catch (err) {
      console.error('Error searching housing ID:', err);
      setError('Failed to load housing details');
    } finally {
      setLoading(false);
    }
  }
};

// Handle click outside to close dropdowns// Handle click outside to close dropdowns
useEffect(() => {
  const handleClickOutside = (event) => {
    if (blockDropdownRef.current && !blockDropdownRef.current.contains(event.target)) {
      setShowBlockDropdown(false);
    }
    if (panchayatDropdownRef.current && !panchayatDropdownRef.current.contains(event.target)) {
      setShowPanchayatDropdown(false);
    }
    if (nameDropdownRef.current && !nameDropdownRef.current.contains(event.target)) {
      setShowNameDropdown(false);
    }
  };

  document.addEventListener('mousedown', handleClickOutside);
  return () => document.removeEventListener('mousedown', handleClickOutside);
}, []);
const isFinalStageSelected = () => {
  if (!formData.stageOfConstruction || !schemeDetails?.detail?.length) return false;

  const stages = schemeDetails.detail
    .map(stage => stage?.name)
    .filter(Boolean);

  if (!stages.length) return false;

  return stages[stages.length - 1].toLowerCase().trim() ===
    formData.stageOfConstruction.toLowerCase().trim();
};

const validateForm = () => {
  const errors = {};

  // Basic validations
  if (!houseData) {
    errors.housingId = 'Please select a valid Housing ID';
  }

  if (!formData.constructionOngoing) {
    errors.constructionOngoing = 'Please select if construction is ongoing';
  }

  if (!formData.additionalRemarks?.trim()) {
    errors.additionalRemarks = 'Remarks is required';
  }

  // Construction not ongoing validations
  if (formData.constructionOngoing === 'no') {
    if (!formData.reasonNotOngoing) {
      errors.reasonNotOngoing = 'Please select reason for construction not ongoing';
    }

    if (formData.reasonNotOngoing === 'Others' && !formData.otherReason.trim()) {
      errors.otherReason = 'Please specify other reason';
    }

    // // Photo validation
    // if (!photoData || photoData.length < 1) {
    //   errors.photos = 'Please capture minimum 1 location photo';
    // }

    // If construction is not ongoing, skip all other validations
    return errors;
  }

  // Only validate below fields if construction IS ongoing
  if (!formData.stageOfConstruction) {
    errors.stageOfConstruction = 'Please select construction stage';
  }

  // Basement-specific validations
  if ((houseData?.stage === 'Basement Construction' || !houseData?.stage) && 
      !houseData?.inspection?.some(inspection => inspection.stage_data?.go50_received === 'yes')) {
    if (!formData.go50Received) {
      errors.go50Received = 'Please confirm GO 50 bandalmann housing receipt status';
    }
  }

  // Toilet construction validation
  if (schemeDetails?.detail) {
    const allStages = schemeDetails.detail.map(stage => stage.name.toLowerCase().trim());
    const currentStageIndex = allStages.findIndex(stage => 
      stage === formData.stageOfConstruction.toLowerCase().trim()
    );
    const lintelIndex = allStages.findIndex(stage => 
      stage.includes('lintel') || stage.includes('lintal')
    );
    
    const isAtOrAfterLintel = currentStageIndex >= lintelIndex && lintelIndex !== -1;
    const notAnsweredYes = !houseData?.inspection?.some(inspection => 
      inspection.stage_data?.toilet_constructed === 'yes'
    );
    
    if (isAtOrAfterLintel && notAnsweredYes && !formData.toiletConstructed) {
      errors.toiletConstructed = 'Please confirm toilet construction status';
    }
  }

  // House size validation
  if ((houseData?.stage === 'Basement Construction' || !houseData?.stage) && 
      !houseData?.inspection?.some(inspection => 
        inspection.house_size && inspection.house_size.trim() !== ''
      ) && !formData.houseSize.trim()) {
    errors.houseSize = 'Please enter the size of the house';
  }

  // Amount received validation
  if (!formData.paymentReceived) {
    errors.paymentReceived = 'Please select whether amount was received';
  }

  if (formData.paymentReceived === 'yes') {
    const amount = Number(formData.totalAmountReceived);
    if (formData.totalAmountReceived === '' || !Number.isFinite(amount) || amount <= 0) {
      errors.totalAmountReceived = 'Please enter the amount received';
    }
  }

  if (
    formData.paymentReceived === 'no' &&
    isFinalStageSelected() &&
    !formData.confirmNoAmountAtFinalStage
  ) {
    errors.confirmNoAmountAtFinalStage =
      'Please confirm that no amount was received by the beneficiary';
  }

  // Material validations
  if (schemeDetails?.detail) {
    const allStages = schemeDetails.detail;
    const selectedIndex = allStages.findIndex(stage => 
      stage.name.toLowerCase().trim() === formData.stageOfConstruction.toLowerCase().trim()
    );
    
    if (selectedIndex !== -1) {
      const stagesToCheck = allStages.slice(0, selectedIndex + 1);
      
      const materialStages = stagesToCheck.filter(stage => 
        (stage.cement && stage.cement.trim() !== '') || (stage.steel && stage.steel.trim() !== '')
      );
      const materialNeededStages = materialStages.filter(stage => 
        !houseData?.inspection?.some(inspection => 
          inspection.stage_data?.materials?.[stage.name]?.provided === 'yes'
        )
      );
      
      for (const stage of materialNeededStages) {
        const fieldName = `materialProvided_${stage.name.replace(/\s+/g, '_')}`;
        if (formData.hasOwnProperty(fieldName) && !formData[fieldName]) {
          errors[fieldName] = `Please confirm material provision for ${stage.name}`;
        }
      }
      
      // MGNREGS validations
      const mgnregsStages = stagesToCheck.filter(stage => stage.wages && stage.wages.trim() !== '');
      const mgnregsNeededStages = mgnregsStages.filter(stage => 
        !houseData?.inspection?.some(inspection => {
          const stageDataMgnregs = inspection.stage_data?.mgnregs?.[stage.name]?.received;
          return stageDataMgnregs === 'yes';
        })
      );
      
      for (const stage of mgnregsNeededStages) {
        const fieldName = `mgnregsReceived_${stage.name.replace(/\s+/g, '_')}`;
        if (formData.hasOwnProperty(fieldName) && !formData[fieldName]) {
          errors[fieldName] = `Please confirm MGNREGS employment for ${stage.name}`;
        }
      }
    }
  }

  // Financing source validation
  if (!formData.financingSource || formData.financingSource.length === 0) {
    errors.financingSource = 'Please select at least one source of financing';
  }

  if (formData.financingSource.includes('others') && !formData.otherFinancingSource.trim()) {
    errors.otherFinancingSource = 'Please specify other financing source';
  }

  // Photo validation - count only successfully uploaded photos with a server path.
  const validPhotoPaths = Array.isArray(photoData)
    ? photoData.map(photo => photo?.path).filter(Boolean)
    : [];

  if (validPhotoPaths.length < 1) {
    errors.photos = 'Please capture and upload minimum 1 location photo';
  }

  return errors;
};


const handleSaveDraft = async () => {
  // Draft save requires only a selected house. Incomplete form fields are allowed.
  if (!houseData?.id) {
    setFieldErrors({
      housingId: 'Please select a valid Housing ID'
    });

    setError('Please select a Housing ID before saving draft');

    const housingElement = document.querySelector('[data-field="housingId"]');
    if (housingElement) {
      housingElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    return;
  }

  setSavingDraft(true);
  setError('');
  setSuccess('');

  try {
    const token = localStorage.getItem('token');
    const imagePaths = Array.isArray(photoData)
      ? photoData.map(photo => photo?.path).filter(Boolean)
      : [];

    const payload = {
     inspect: String(
        formData.inspectionDate ||
        new Date().toISOString().split('T')[0]
      ).split('T')[0],

      progress: {
        stage:
          formData.stageOfConstruction ||
          houseData?.stage ||
          '',
        achieved:
          formData.dateStageAchieved ||
          formData.inspectionDate ||
          ''
      },

      stage_data: {
        construction_ongoing: formData.constructionOngoing || '',
        status: formData.stageOfConstruction || '',
        stage: formData.stageOfConstruction || '',
        reason_not_ongoing:
          formData.reasonNotOngoing === 'Others'
            ? formData.otherReason
            : formData.reasonNotOngoing,
        amount_received: formData.paymentReceived || '',
        total_amount_received:
          formData.totalAmountReceived === ''
            ? ''
            : Number(formData.totalAmountReceived),
        zero_amount_confirmed: !!formData.confirmNoAmountAtFinalStage,
        financing_source:
          Array.isArray(formData.financingSource)
            ? formData.financingSource.join(', ')
            : ''
      },

      house_size: formData.houseSize || '',
      remarks: formData.additionalRemarks || '',
      images: imagePaths,
      workflow_status: 'Draft',

      // Full snapshot used when the same Housing ID is reopened.
      draft_form: {
        ...formData
      }
    };

    const isUpdatingDraft = !!draftInspectionId;
    const url = isUpdatingDraft
      ? `${API_BASE_URL}/project/house/${houseData.id}/inspect/${draftInspectionId}`
      : `${API_BASE_URL}/project/house/${houseData.id}/inspect`;

    console.log('Draft payload:', payload);
    console.log('Draft image paths:', imagePaths);

    const response = await fetch(url, {
      method: isUpdatingDraft ? 'PUT' : 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || 'Failed to save draft');
    }

    const savedDraftId =
      data.data?.draftId ||
      data.data?.insertId ||
      draftInspectionId;

    if (savedDraftId) {
      setDraftInspectionId(savedDraftId);
    }

    setSuccess(
      data.message ||
      'Draft saved successfully. Select the same Housing ID later to continue.'
    );

    // Do not clear the form after Save Draft.
    setFieldErrors({});

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } catch (err) {
    console.error('Save draft error:', err);
    setError(err.message || 'Failed to save draft');

    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } finally {
    setSavingDraft(false);
  }
};


const handleSubmit = async () => {
  // Validate form and get all errors
  const errors = validateForm();
  setFieldErrors(errors);

  // If there are errors, scroll to first error and show message
  if (Object.keys(errors).length > 0) {
    setError('Please fix the errors highlighted below');
    
    // Scroll to first error field
    const firstErrorField = Object.keys(errors)[0];
    const errorElement = document.querySelector(`[data-field="${firstErrorField}"]`);
    if (errorElement) {
      errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
    
    return; // Stop submission
  }

  // If validation passes, clear any previous errors and proceed
  setSubmitting(true);
  setError('');
  setSuccess('');
  setFieldErrors({});

  try {
    const token = localStorage.getItem('token');
    
    // Helper function to collect stage-specific data
    const collectStageSpecificData = () => {
      const stageData = {};
      
      if (!schemeDetails?.detail) return stageData;
      
      const allStages = schemeDetails.detail;
      const selectedIndex = allStages.findIndex(stage => 
        stage.name.toLowerCase().trim() === formData.stageOfConstruction.toLowerCase().trim()
      );
      
      if (selectedIndex === -1) return stageData;
      
      const stagesToCheck = allStages.slice(0, selectedIndex + 1);
      
      // Collect amount received data
      stageData.payments = {};
      stageData.amount_received = formData.paymentReceived;
      stageData.total_amount_received =
        formData.paymentReceived === 'yes'
          ? Number(formData.totalAmountReceived)
          : 0;

      if (formData.paymentReceived === 'no' && isFinalStageSelected()) {
        stageData.zero_amount_confirmed = formData.confirmNoAmountAtFinalStage;
      }
      
      // Collect material data for all relevant stages
      const materialStages = stagesToCheck.filter(stage => 
        (stage.cement && stage.cement.trim() !== '') || (stage.steel && stage.steel.trim() !== '')
      );
      const materialNeededStages = materialStages.filter(stage => 
        !houseData?.inspection?.some(inspection => 
          inspection.stage_data?.materials?.[stage.name]?.provided === 'yes'
        )
      );
      stageData.materials = {};
      materialNeededStages.forEach(stage => {
        const fieldName = `materialProvided_${stage.name.replace(/\s+/g, '_')}`;
        if (formData[fieldName]) {
          const materialData = {
            provided: formData[fieldName]
          };
          
          if (formData[fieldName] === 'no') {
            const cementField = `cementReceived_${stage.name.replace(/\s+/g, '_')}`;
            const steelField = `steelReceived_${stage.name.replace(/\s+/g, '_')}`;
            
            if (formData[cementField]) materialData.cement_received = parseInt(formData[cementField]);
            if (formData[steelField]) materialData.steel_received = parseInt(formData[steelField]);
          }
          
          stageData.materials[stage.name] = materialData;
        }
      });
      
      // Collect MGNREGS data for all relevant stages
      const mgnregsStages = stagesToCheck.filter(stage => stage.wages && stage.wages.trim() !== '');
      const mgnregsNeededStages = mgnregsStages.filter(stage => 
        !houseData?.inspection?.some(inspection => {
          const stageDataMgnregs = inspection.stage_data?.mgnregs?.[stage.name]?.received;
          return stageDataMgnregs === 'yes';
        })
      );
      stageData.mgnregs = {};
      mgnregsNeededStages.forEach(stage => {
        const fieldName = `mgnregsReceived_${stage.name.replace(/\s+/g, '_')}`;
        if (formData[fieldName]) {
          const mgnregsData = {
            received: formData[fieldName],
            amount: parseInt(stage.wages)
          };
          
          if (formData[fieldName] === 'no') {
            const daysField = `mgnregsDaysReceived_${stage.name.replace(/\s+/g, '_')}`;
            if (formData[daysField]) {
              mgnregsData.days_received = parseInt(formData[daysField]);
            }
          }
          
          stageData.mgnregs[stage.name] = mgnregsData;
        }
      });
      
      // Add financing and help data to current stage
      stageData.financing_source = formData.financingSource.includes('others') 
        ? [...formData.financingSource.filter(s => s !== 'others'), formData.otherFinancingSource].join(', ')
        : formData.financingSource.join(', ');
      stageData.help_needed = formData.helpNeeded;
      
      // Add basement-specific fields if applicable
      if (formData.go50Received) {
        stageData.go50_received = formData.go50Received;
      }
      if (formData.toiletConstructed) {
        stageData.toilet_constructed = formData.toiletConstructed;
      }
      
      // Add current stage specific data
      stageData.construction_ongoing = formData.constructionOngoing;
      if (formData.constructionOngoing === 'no') {
        stageData.reason_not_ongoing = formData.reasonNotOngoing === 'Others' ? formData.otherReason : formData.reasonNotOngoing;
      }
      stageData.status = formData.stageOfConstruction;
      stageData.stage = formData.stageOfConstruction;

      return stageData;
    };
    
    // Collect all stage-specific data
    const stageSpecificData = collectStageSpecificData();
    
    // Build the payload
// Build the payload
    let payload;
    
    if (formData.constructionOngoing === 'no') {
      // If construction not ongoing, send minimal payload
      payload = {
        inspect: String(formData.inspectionDate || '').split('T')[0],
        progress: {
          stage: 'construction not ongoing',
          achieved: formData.inspectionDate
        },
        stage_data: {
          construction_ongoing: 'no',
          status: 'Construction Not Ongoing',
          reason_not_ongoing: formData.reasonNotOngoing === 'Others' ? formData.otherReason : formData.reasonNotOngoing
        },
        remarks: formData.additionalRemarks,
        images: photoData.map(photo => photo?.path).filter(Boolean),
        workflow_status: 'Submitted',
        draft_form: { ...formData }
      };
    } else {
      // If construction ongoing, send full payload
      payload = {
        inspect: formData.inspectionDate,
        progress: {
          stage: formData.stageOfConstruction,
          achieved: formData.dateStageAchieved || formData.inspectionDate
        },
        stage_data: stageSpecificData,
        house_size: formData.houseSize,
        remarks: formData.additionalRemarks,
        images: photoData.map(photo => photo?.path).filter(Boolean),
        workflow_status: 'Submitted',
        draft_form: { ...formData }
      };
    }
    
    console.log('Payload being sent:', JSON.stringify(payload, null, 2));

    const isSubmittingDraft = !!draftInspectionId;
    const submitUrl = isSubmittingDraft
      ? `${API_BASE_URL}/project/house/${houseData.id}/inspect/${draftInspectionId}`
      : `${API_BASE_URL}/project/house/${houseData.id}/inspect`;

    console.log('Final inspection image paths:', payload.images);

    const response = await fetch(submitUrl, {
      method: isSubmittingDraft ? 'PUT' : 'POST',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    });

    const data = await response.json();
    
    if (response.ok) {
      setShowSuccessModal(true);
      
      // Reset form
      setFormData({
        inspectionDate: new Date().toISOString().split('T')[0],
        housingId: '',
        beneficiaryName: '',
        mobile: '',
        district: '',
        block: '',
        panchayat: '',
        scheme: '',
        aadhar: '',
        stageOfConstruction: '',
        constructionOngoing: '',
        reasonNotOngoing: '',
        otherReason: '',
        additionalRemarks: '',
        paymentReceived: '',
        totalAmountReceived: '',
        confirmNoAmountAtFinalStage: false,
        go50Received: '',
        houseSize: '',
        financingSource: [],
        otherFinancingSource: '',
        helpNeeded: '',
        toiletConstructed: '',
        ...Object.keys(formData).reduce((acc, key) => {
          if (key.includes('totalAmountReceived') ||
              key.includes('materialProvided_') || 
              key.includes('cementReceived_') || 
              key.includes('steelReceived_') || 
              key.includes('mgnregsReceived_') || 
              key.includes('mgnregsDaysReceived_')) {
            acc[key] = '';
          }
          return acc;
        }, {})
      });
      
      setHouseData(null);
      setDraftInspectionId(null);
      setPhotoData([]);
      setHousingOptions([]);
      setBlockSearch('');
      setPanchayatSearch('');
      setNameSearch('');
      setResetPhotoTrigger(prev => prev + 1);
      setFieldErrors({}); // Clear field errors
    } else {
      setError(data.message || 'Failed to submit inspection');
    }
  } catch (err) {
    console.error('Submit error:', err);
    setError('Network error. Please try again.');
  } finally {
    setSubmitting(false);
  }
};
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 py-6">
        <div className="space-y-6">
          
          {/* Header */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h1 className="text-2xl font-bold text-gray-900 mb-2">Housing Inspection Form</h1>
            <p className="text-gray-600">Record inspection details and construction progress</p>
          </div>

          {/* Success/Error Messages */}
          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 px-4 py-3 rounded-lg">
              {error}
            </div>
          )}

   {success && !showSuccessModal && (
  <div className="bg-green-50 border border-green-200 text-green-600 px-4 py-3 rounded-lg">
    {success}
  </div>
)}
{/* Success Modal */}
{showSuccessModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white rounded-lg p-8 max-w-md mx-4 text-center">
      <div className="mb-4">
        <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
      </div>
      <h3 className="text-xl font-semibold text-gray-900 mb-2">Success!</h3>
      <p className="text-gray-600 mb-6">
        Inspection has been submitted successfully. 
      </p>
      <button
        onClick={() => {
          setShowSuccessModal(false);
          setSuccess('');
          setError('');
        }}
        className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md font-medium"
      >
        Continue
      </button>
    </div>
  </div>
)}
          {/* Basic Information - Simplified */}
          <div className="bg-white rounded-lg shadow-sm border p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Basic Information</h2>
            
<div className="grid grid-cols-1 md:grid-cols-6 gap-4 mb-4">
 <div>
  <label className="text-sm font-medium text-gray-700 mb-2 block">Inspection Date *</label>
  <input
    type="date"
    value={formData.inspectionDate}
    readOnly
    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md bg-gray-100 cursor-not-allowed"
  />
</div>

   <div data-field="housingId">
                <label className="text-sm font-medium text-gray-700 mb-2 block">Housing ID *</label>
                <div className="relative">
                  <input
                    type="text"
                    value={formData.housingId}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    placeholder="Type to search Housing ID..."
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  />
                  {loading && (
                    <p className="text-xs text-blue-600 mt-1">Searching...</p>
                  )}
                  {housingOptions.length > 0 && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                      {housingOptions.map(house => (
                        <div
                          key={house.id}
                          onClick={() => handleHousingIdChange(house)}
                          className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                        >
                          <div className="font-medium">{house.h_id}</div>
                          <div className="text-gray-600 text-xs">{house.beneficiary} - {house.mobile}</div>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <div ref={blockDropdownRef}>
  <label className="text-sm font-medium text-gray-700 mb-2 block">Block</label>
  <div className="relative">
    <input
      type="text"
      value={blockSearch}
      onChange={(e) => {
        setBlockSearch(e.target.value);
        setShowBlockDropdown(true);
      }}
      onFocus={() => setShowBlockDropdown(true)}
      placeholder="Search and select Block..."
      className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
    />
    <ChevronDown className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
    
    {showBlockDropdown && (
      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
        {filteredBlocks.length > 0 ? (
          filteredBlocks.map((block, index) => (
            <div
              key={block.id || index}
              onClick={() => handleBlockSelect(block)}
              className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
            >
              {block.name || block}
            </div>
          ))
        ) : (
          <div className="px-3 py-2 text-sm text-gray-500">No blocks found</div>
        )}
      </div>
    )}
  </div>
</div>

   <div ref={panchayatDropdownRef}>
                <label className="text-sm font-medium text-gray-700 mb-2 block">Panchayat</label>
                <div className="relative">
        <input
  type="text"
  value={panchayatSearch}
  onChange={(e) => {
    setPanchayatSearch(e.target.value);
    setShowPanchayatDropdown(true);
  }}
  onFocus={() => setShowPanchayatDropdown(true)}
  placeholder={formData.block ? "Search and select Panchayat..." : "Select Block first"}
  disabled={!formData.block}
  className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
/>
                  <ChevronDown className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
                  
                  {showPanchayatDropdown && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
                      {filteredPanchayats.length > 0 ? (
                        filteredPanchayats.map((panchayat, index) => (
                          <div
                            key={panchayat.id || index}
                            onClick={() => handlePanchayatSelect(panchayat)}
                            className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                          >
                            {panchayat.name || panchayat}
                          </div>
                        ))
                      ) : (
                        <div className="px-3 py-2 text-sm text-gray-500">No panchayats found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
       <div ref={nameDropdownRef}>
                <label className="text-sm font-medium text-gray-700 mb-2 block">Name</label>
                <div className="relative">
                  <input
                    type="text"
                    value={nameSearch}
                    onChange={(e) => {
                      setNameSearch(e.target.value);
                      setShowNameDropdown(true);
                    }}
                    onFocus={() => setShowNameDropdown(true)}
             placeholder={formData.panchayat ? (loading ? "Loading..." : "Search and select Name...") : "Select Panchayat first"}
                    disabled={!formData.panchayat || loading}
                    className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 disabled:bg-gray-100 disabled:cursor-not-allowed"
                  />
                  <ChevronDown className="absolute right-3 top-2.5 h-4 w-4 text-gray-400 pointer-events-none" />
                  
                  {showNameDropdown && formData.panchayat && (
                    <div className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
   {loading ? (
                        <div className="px-3 py-2 text-sm text-gray-500 flex items-center">
                          <div className="animate-spin h-3 w-3 border-2 border-blue-500 border-t-transparent rounded-full mr-2"></div>
                          Loading housing details...
                        </div>
                      ) : filteredNames.length > 0 ? (
                        filteredNames.map((name, index) => (
                          <div
                            key={name.id || index}
                            onClick={() => handleNameSelect(name)}
                            className="px-3 py-2 text-sm hover:bg-gray-100 cursor-pointer border-b border-gray-100 last:border-b-0"
                          >
                            <div className="font-medium">{name.beneficiary}</div>
                            <div className="text-gray-600 text-xs">ID: {name.h_id}</div>
                          </div>
                        ))
                      ) : (
                        <div className="px-3 py-2 text-sm text-gray-500">No beneficiaries found</div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            </div>


{/* Property Information Grid */}
{houseData && (
  <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 mb-6">
    <h3 className="text-md font-semibold text-gray-900 mb-4 pb-2 border-b border-blue-200">Property Information</h3>
    
    {/* First Row: Housing ID, Panchayat, Block, Scheme, Year */}
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-6">
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Housing ID</label>
        <div className="text-sm text-gray-900 font-medium">{formData.housingId}</div>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Panchayat</label>
        <div className="text-sm text-gray-900 font-medium">{formData.panchayat}</div>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Block</label>
        <div className="text-sm text-gray-900 font-medium">{formData.block}</div>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Scheme</label>
        <div className="text-sm text-gray-900 font-medium">{formData.scheme}</div>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Year</label>
        <div className="text-sm text-gray-900 font-medium">{houseData.s_year || 'N/A'}</div>
      </div>
    </div>

    {/* Second Row: Name, Mobile, Aadhar */}
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Beneficiary Name</label>
        <div className="text-sm text-gray-900 font-medium">{formData.beneficiaryName}</div>
      </div>
      <div>
        <label className="text-sm font-medium text-gray-600 block mb-1">Mobile Number</label>
        <div className="text-sm text-gray-900 font-medium">{formData.mobile}</div>
      </div>


    </div>
  </div>
)}
{/* Recent Inspections */}
{houseData && houseData.inspection && houseData.inspection.length > 0 && houseData.inspection[0] !== null && (
  <div className="mb-6">
    <h3 className="text-md font-semibold text-gray-900 mb-4 pb-2 border-b border-blue-200">Recent Inspections</h3>
    <div className="overflow-x-auto">
      <table className="w-full border border-gray-200 rounded-lg">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-4 py-3 text-left text-sm font-medium text-gray-600 border-b border-gray-200">Inspection Date</th>
            <th className="px-4 py-3 text-left text-sm font-medium text-gray-600 border-b border-gray-200">Construction Stage</th>
            <th className="px-4 py-3 text-left text-sm font-medium text-gray-600 border-b border-gray-200">Remarks</th>
          </tr>
        </thead>
        <tbody className="bg-white">
      {houseData.inspection.slice(-3).reverse().filter(inspection => inspection !== null).map((inspection, index) => (
 <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
  <td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">{new Date(inspection.inspected).toLocaleDateString()}</td>
<td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">
  {inspection.stage_data?.status || inspection.stage_data?.stage || inspection.status || 'N/A'}
</td>
  <td className="px-4 py-3 text-sm text-gray-900 border-b border-gray-200">{inspection.remarks || 'N/A'}</td>
</tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

          </div>
{/* Construction Progress */}
<div className="bg-white rounded-lg shadow-sm border p-6">
<div className="flex items-center gap-3 mb-4">
  <h2 className="text-lg font-semibold text-gray-900">Construction Progress</h2>
  {getCurrentStage() && (
    <span className="px-3 py-1 bg-blue-100 text-blue-800 text-sm font-medium rounded-full border border-blue-200">
      {getCurrentStage()}
    </span>
  )}
</div>

{/* First Question: Construction Status */}
<div className="mb-6" data-field="constructionOngoing">
  <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-6">
    <div className="flex items-center gap-4">
      <label className="text-sm font-medium text-gray-700">
        Is construction ongoing? *
      </label>
      <div className="flex gap-4">
        <label className="flex items-center">
          <input
            type="radio"
            name="constructionOngoing"
            value="yes"
            checked={formData.constructionOngoing === 'yes'}
            onChange={(e) => {
              handleInputChange('constructionOngoing', e.target.value);
              handleInputChange('reasonNotOngoing', '');
              handleInputChange('otherReason', '');
              setFieldErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.constructionOngoing;
                return newErrors;
              });
            }}
            className="mr-2"
          />
          Yes
        </label>
        <label className="flex items-center">
          <input
            type="radio"
            name="constructionOngoing"
            value="no"
            checked={formData.constructionOngoing === 'no'}
            onChange={(e) => {
              handleInputChange('constructionOngoing', e.target.value);
              setFieldErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.constructionOngoing;
                return newErrors;
              });
            }}
            className="mr-2"
          />
          No
        </label>
      </div>
    </div>

    {/* Reason section - responsive layout */}
    {formData.constructionOngoing === 'no' && (
      <div className="flex flex-col sm:flex-row sm:items-end gap-4">
        <div data-field="reasonNotOngoing">
          <label className="text-sm font-medium text-gray-700 mb-1 block">
            Reason *
          </label>
          <select
            value={formData.reasonNotOngoing}
            onChange={(e) => {
              handleInputChange('reasonNotOngoing', e.target.value);
              if (e.target.value !== 'Others') {
                handleInputChange('otherReason', '');
              }
              setFieldErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors.reasonNotOngoing;
                return newErrors;
              });
            }}
            className={`w-full sm:w-56 px-3 py-2 text-sm border rounded-md ${
              fieldErrors.reasonNotOngoing ? 'border-red-500' : 'border-gray-300'
            }`}
          >
            <option value="">Select reason</option>
            {reasonsNotOngoing.map(reason => (
              <option key={reason} value={reason}>{reason}</option>
            ))}
          </select>
          {fieldErrors.reasonNotOngoing && (
            <p className="text-red-600 text-xs mt-1">{fieldErrors.reasonNotOngoing}</p>
          )}
        </div>

        {formData.reasonNotOngoing === 'Others' && (
          <div data-field="otherReason">
            <label className="text-sm font-medium text-gray-700 mb-1 block">
              Specify other reason *
            </label>
            <input
              type="text"
              value={formData.otherReason}
              onChange={(e) => {
                handleInputChange('otherReason', e.target.value);
                setFieldErrors(prev => {
                  const newErrors = { ...prev };
                  delete newErrors.otherReason;
                  return newErrors;
                });
              }}
              placeholder="Enter other reason..."
              maxLength={100}
              className={`w-full sm:w-64 px-3 py-2 text-sm border rounded-md ${
                fieldErrors.otherReason ? 'border-red-500' : 'border-gray-300'
              }`}
            />
            {fieldErrors.otherReason && (
              <p className="text-red-600 text-xs mt-1">{fieldErrors.otherReason}</p>
            )}
          </div>
        )}
      </div>
    )}
  </div>
  {fieldErrors.constructionOngoing && (
    <p className="text-red-600 text-sm mt-2">{fieldErrors.constructionOngoing}</p>
  )}
</div>

{/* Only show the rest if construction is ongoing */}
{formData.constructionOngoing === 'yes' && (
  <>
{/* Second Question: House Size - Ask until value is provided */}
{!houseData?.inspection?.some(inspection => 
  inspection.house_size && inspection.house_size.trim() !== ''
) && (
  <div className="mb-6" data-field="houseSize">
    <div className="flex items-center gap-4">
      <label className="text-sm font-medium text-gray-700">
        Size of the house *
        {schemeDetails?.area && (
          <span className="text-gray-500 text-xs ml-2">
            (Allotted: {schemeDetails.area} sq ft)
          </span>
        )}
      </label>
      <input
        type="text"
        value={formData.houseSize}
        onChange={(e) => {
          handleInputChange('houseSize', e.target.value);
          setFieldErrors(prev => {
            const newErrors = { ...prev };
            delete newErrors.houseSize;
            return newErrors;
          });
        }}
        placeholder="Enter house size (e.g., 500 sq ft)"
        className={`w-64 px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
          fieldErrors.houseSize ? 'border-red-500' : 'border-gray-300'
        }`}
      />
    </div>
    
{/* Validation error message */}
    {fieldErrors.houseSize && (
      <p className="text-red-600 text-sm mt-2">{fieldErrors.houseSize}</p>
    )}
    
    {/* Warning messages for house size */}
    {formData.houseSize && schemeDetails?.area && (() => {
      const enteredSize = parseFloat(formData.houseSize.replace(/[^0-9.]/g, ''));
      const allottedSize = parseFloat(schemeDetails.area);
      
      if (!isNaN(enteredSize) && !isNaN(allottedSize)) {
        if (enteredSize < allottedSize) {
          return (
            <p className="text-red-600 text-sm mt-2 flex items-start gap-2">
              <span className="text-red-600 font-bold">⚠</span>
              <span>House size is less than allotted size. Please check.</span>
            </p>
          );
        } else if (enteredSize > (allottedSize * 2)) {
          return (
            <p className="text-red-600 text-sm mt-2 flex items-start gap-2">
              <span className="text-red-600 font-bold">⚠</span>
              <span>House size is much more than allotted size. Please check.</span>
            </p>
          );
        }
      }
      return null;
    })()}
  </div>
)}
{/* Third Question: Stage of Construction */}
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
      <div data-field="stageOfConstruction">
        <label className="text-sm font-medium text-gray-700 mb-2 block">
          Stage of Construction *
        </label>
        <select
          value={formData.stageOfConstruction}
          onChange={(e) => {
            handleInputChange('stageOfConstruction', e.target.value);
            setFieldErrors(prev => {
              const newErrors = { ...prev };
              delete newErrors.stageOfConstruction;
              return newErrors;
            });
          }}
          className={`w-full px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
            fieldErrors.stageOfConstruction ? 'border-red-500' : 'border-gray-300'
          }`}
        >
          <option value="">Select construction stage</option>
          {getAvailableStages().map(stage => (
            <option key={stage} value={stage}>{stage}</option>
          ))}
        </select>
        {fieldErrors.stageOfConstruction && (
          <p className="text-red-600 text-xs mt-1">{fieldErrors.stageOfConstruction}</p>
        )}
      </div>
    </div>

    {formData.stageOfConstruction && (
      <div className="space-y-4">
        
{/* GO 50 Bandalmann - Only for Basement Construction */}
{!houseData?.inspection?.some(inspection => 
  inspection.stage_data?.go50_received === 'yes'
) && formData.stageOfConstruction !== 'Physical Completion' && (
          <div data-field="go50Received">
            <div className="flex items-center gap-4">
              <label className="text-sm font-medium text-gray-700">
                Vandalmann - Received or no? *
              </label>
              <div className="flex gap-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="go50Received"
                    value="yes"
                    checked={formData.go50Received === 'yes'}
                    onChange={(e) => {
                      handleInputChange('go50Received', e.target.value);
                      setFieldErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors.go50Received;
                        return newErrors;
                      });
                    }}
                    className="mr-2"
                  />
                  Yes
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name="go50Received"
                    value="no"
                    checked={formData.go50Received === 'no'}
                    onChange={(e) => {
                      handleInputChange('go50Received', e.target.value);
                      setFieldErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors.go50Received;
                        return newErrors;
                      });
                    }}
                    className="mr-2"
                  />
                  No
                </label>
              </div>
            </div>
            {fieldErrors.go50Received && (
              <p className="text-red-600 text-sm mt-2">{fieldErrors.go50Received}</p>
            )}
          </div>
        )}
{/* Toilet Construction - Only show from Lintal Level onwards, ask until answered "yes" */}
{(() => {
  if (!formData.stageOfConstruction || !schemeDetails?.detail) return null;
  
  const allStages = schemeDetails.detail.map(stage => stage.name.toLowerCase().trim());
  const currentStageIndex = allStages.findIndex(stage => 
    stage === formData.stageOfConstruction.toLowerCase().trim()
  );
  
  const lintalIndex = allStages.findIndex(stage => 
    stage.includes('lintel') || stage.includes('lintal')
  );
  
  const isAtOrAfterLintal = currentStageIndex >= lintalIndex && lintalIndex !== -1;
  const notAnsweredYes = !houseData?.inspection?.some(inspection => 
    inspection.stage_data?.toilet_constructed === 'yes'
  );
  
  return isAtOrAfterLintal && notAnsweredYes && (
    <div data-field="toiletConstructed">
      <div className="flex items-center gap-4">
        <label className="text-sm font-medium text-gray-700">
          Has the toilet been constructed? *
        </label>
        <div className="flex gap-4">
          <label className="flex items-center">
            <input
              type="radio"
              name="toiletConstructed"
              value="yes"
              checked={formData.toiletConstructed === 'yes'}
              onChange={(e) => {
                handleInputChange('toiletConstructed', e.target.value);
                setFieldErrors(prev => {
                  const newErrors = { ...prev };
                  delete newErrors.toiletConstructed;
                  return newErrors;
                });
              }}
              className="mr-2"
            />
            Yes
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="toiletConstructed"
              value="no"
              checked={formData.toiletConstructed === 'no'}
              onChange={(e) => {
                handleInputChange('toiletConstructed', e.target.value);
                setFieldErrors(prev => {
                  const newErrors = { ...prev };
                  delete newErrors.toiletConstructed;
                  return newErrors;
                });
              }}
              className="mr-2"
            />
            No
          </label>
        </div>
      </div>
      {fieldErrors.toiletConstructed && (
        <p className="text-red-600 text-sm mt-2">{fieldErrors.toiletConstructed}</p>
      )}
    </div>
  );
})()}

{/* Amount Received */}
<div className="mb-6" data-field="paymentReceived">
  <div className="flex flex-col lg:flex-row lg:items-center gap-4">
    <label className="text-sm font-medium text-gray-700">
      Amount Received? *
    </label>
    <div className="flex gap-6">
      <label className="flex items-center">
        <input
          type="radio"
          name="paymentReceived"
          value="yes"
          checked={formData.paymentReceived === 'yes'}
          onChange={(e) => {
            handleInputChange('paymentReceived', e.target.value);
            setFieldErrors(prev => {
              const next = { ...prev };
              delete next.paymentReceived;
              delete next.confirmNoAmountAtFinalStage;
              return next;
            });
          }}
          className="mr-2"
        />
        Yes
      </label>

      <label className="flex items-center">
        <input
          type="radio"
          name="paymentReceived"
          value="no"
          checked={formData.paymentReceived === 'no'}
          onChange={(e) => {
            handleInputChange('paymentReceived', e.target.value);
            handleInputChange('totalAmountReceived', '');
            setFieldErrors(prev => {
              const next = { ...prev };
              delete next.paymentReceived;
              delete next.totalAmountReceived;
              return next;
            });
          }}
          className="mr-2"
        />
        No
      </label>
    </div>
  </div>

  {fieldErrors.paymentReceived && (
    <p className="text-red-600 text-sm mt-2">{fieldErrors.paymentReceived}</p>
  )}
</div>

{formData.paymentReceived === 'yes' && (
  <div className="mb-6" data-field="totalAmountReceived">
    <div className="flex items-center gap-4">
      <label className="text-sm font-medium text-gray-700">
        How much amount received so far? *
      </label>
      <input
        type="number"
        value={formData.totalAmountReceived || ''}
        onChange={(e) => {
          handleInputChange('totalAmountReceived', e.target.value);
          setFieldErrors(prev => {
            const next = { ...prev };
            delete next.totalAmountReceived;
            return next;
          });
        }}
        placeholder="Enter total amount received"
        min="1"
        className={`w-48 px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
          fieldErrors.totalAmountReceived ? 'border-red-500' : 'border-gray-300'
        }`}
      />
    </div>
    {fieldErrors.totalAmountReceived && (
      <p className="text-red-600 text-sm mt-2">{fieldErrors.totalAmountReceived}</p>
    )}
  </div>
)}

{formData.paymentReceived === 'no' && isFinalStageSelected() && (
  <div className="mb-6" data-field="confirmNoAmountAtFinalStage">
    <label className="flex items-start gap-2 text-sm text-gray-700">
      <input
        type="checkbox"
        checked={formData.confirmNoAmountAtFinalStage}
        onChange={(e) => {
          handleInputChange('confirmNoAmountAtFinalStage', e.target.checked);
          setFieldErrors(prev => {
            const next = { ...prev };
            delete next.confirmNoAmountAtFinalStage;
            return next;
          });
        }}
        className="mt-1"
      />
      <span>
        I confirm that no amount was received by the beneficiary and the total amount received is ₹0.
      </span>
    </label>
    {fieldErrors.confirmNoAmountAtFinalStage && (
      <p className="text-red-600 text-sm mt-2">{fieldErrors.confirmNoAmountAtFinalStage}</p>
    )}
  </div>
)}
{/* Material Provision */}
{(() => {
  if (!formData.stageOfConstruction || !schemeDetails?.detail) return null;
  
  // Get ALL stages first, then find selected stage index
  const allStages = schemeDetails.detail;
  const selectedIndex = allStages.findIndex(stage => 
    stage.name.toLowerCase().trim() === formData.stageOfConstruction.toLowerCase().trim()
  );
  
  if (selectedIndex === -1) return null;
  
  // Get all stages up to selected stage, then filter for material stages
  const stagesToCheck = allStages.slice(0, selectedIndex + 1);
  const materialStages = stagesToCheck.filter(stage => 
    (stage.cement && stage.cement.trim() !== '') || (stage.steel && stage.steel.trim() !== '')
  );

  const materialNeededStages = materialStages.filter(stage => 
    !houseData?.inspection?.some(inspection => {
      // Check only stage_data structure
      return inspection.stage_data?.materials?.[stage.name]?.provided === 'yes';
    })
  );
  
  return materialNeededStages.length > 0 && (
    <div className="space-y-4">
      {materialNeededStages.map(stage => {
        const materials = {};
        if (stage.cement) materials.cement = parseInt(stage.cement);
        if (stage.steel) materials.steel = parseInt(stage.steel);
        const fieldName = `materialProvided_${stage.name.replace(/\s+/g, '_')}`;
        
        return (
          <div key={stage.name} data-field={fieldName}>
            <div className="flex items-center gap-4">
              <label className="text-sm font-medium text-gray-700">
                Material ({formatMaterialString(materials)}) provided for {stage.name}? *
              </label>
              <div className="flex gap-4">
                <label className="flex items-center">
                  <input
                    type="radio"
                    name={fieldName}
                    value="yes"
                    checked={formData[fieldName] === 'yes'}
                    onChange={(e) => {
                      handleInputChange(fieldName, e.target.value);
                      setFieldErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[fieldName];
                        return newErrors;
                      });
                    }}
                    className="mr-2"
                  />
                  Yes
                </label>
                <label className="flex items-center">
                  <input
                    type="radio"
                    name={fieldName}
                    value="no"
                    checked={formData[fieldName] === 'no'}
                    onChange={(e) => {
                      handleInputChange(fieldName, e.target.value);
                      setFieldErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors[fieldName];
                        return newErrors;
                      });
                    }}
                    className="mr-2"
                  />
                  No
                </label>
              </div>
            </div>
            {fieldErrors[fieldName] && (
              <p className="text-red-600 text-sm mt-2">{fieldErrors[fieldName]}</p>
            )}
            
            {/* Show input fields when "No" is selected for this specific stage */}
            {formData[fieldName] === 'no' && (
              <div className="mt-4 flex gap-4">
                {materials.cement && (
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      How many bags of cement received for {stage.name}?
                    </label>
                    <input
                      type="number"
                      value={formData[`cementReceived_${stage.name.replace(/\s+/g, '_')}`] || ''}
                      onChange={(e) => handleInputChange(`cementReceived_${stage.name.replace(/\s+/g, '_')}`, e.target.value)}
                      placeholder="Enter bags of cement"
                      className="w-40 px-3 py-2 text-sm border border-gray-300 rounded-md"
                    />
                  </div>
                )}
                {materials.steel && (
                  <div>
                    <label className="text-sm font-medium text-gray-700 mb-1 block">
                      How many kg of steel received for {stage.name}?
                    </label>
                    <input
                      type="number"
                      value={formData[`steelReceived_${stage.name.replace(/\s+/g, '_')}`] || ''}
                      onChange={(e) => handleInputChange(`steelReceived_${stage.name.replace(/\s+/g, '_')}`, e.target.value)}
                      placeholder="Enter kg of steel"
                      className="w-40 px-3 py-2 text-sm border border-gray-300 rounded-md"
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
})()}

{/* MGNREGS Employment - For all stages */}
{(() => {
  if (!formData.stageOfConstruction || !schemeDetails?.detail) return null;
  
  // Get ALL stages first, then find selected stage index
  const allStages = schemeDetails.detail;
  const selectedIndex = allStages.findIndex(stage => 
    stage.name.toLowerCase().trim() === formData.stageOfConstruction.toLowerCase().trim()
  );
  
  if (selectedIndex === -1) return null;
  
  // Get all stages up to selected stage, then filter for MGNREGS stages
  const stagesToCheck = allStages.slice(0, selectedIndex + 1);
  const mgnregsStages = stagesToCheck.filter(stage => 
    stage.wages && stage.wages.trim() !== ''
  );
const mgnregsNeededStages = mgnregsStages.filter(stage => 
    !houseData?.inspection?.some(inspection => {
      // Only hide question if MGNREGS was fully received (answered "yes")
      const stageDataMgnregs = inspection.stage_data?.mgnregs?.[stage.name]?.received;
      return stageDataMgnregs === 'yes';
    })
  );
  
  return mgnregsNeededStages.length > 0 && (
    <div className="space-y-4">
      {mgnregsNeededStages.map(stage => {
        const fieldName = `mgnregsReceived_${stage.name.replace(/\s+/g, '_')}`;
        
        return (
          <div key={stage.name} data-field={fieldName}>
            <div className="flex items-center gap-4">
              <label className="text-sm font-medium text-gray-700">
                MGNREGS - ₹{parseInt(stage.wages)?.toLocaleString()} employment amount received for {stage.name}? *
              </label>
              <div className="flex gap-4">
                {mgnregsOptions.map(option => (
                  <label key={option} className="flex items-center">
                    <input
                      type="radio"
                      name={fieldName}
                      value={option.toLowerCase()}
                      checked={formData[fieldName] === option.toLowerCase()}
                      onChange={(e) => {
                        handleInputChange(fieldName, e.target.value);
                        setFieldErrors(prev => {
                          const newErrors = { ...prev };
                          delete newErrors[fieldName];
                          return newErrors;
                        });
                      }}
                      className="mr-2"
                    />
                    {option}
                  </label>
                ))}
              </div>
            </div>
            {fieldErrors[fieldName] && (
              <p className="text-red-600 text-sm mt-2">{fieldErrors[fieldName]}</p>
            )}
            
            {/* Show input field when "No" is selected for this specific stage */}
            {formData[fieldName] === 'no' && (
              <div className="mt-4">
                <label className="text-sm font-medium text-gray-700 mb-1 block">
                  How many days payment received so far for {stage.name}?
                </label>
                <input
                  type="number"
                  value={formData[`mgnregsDaysReceived_${stage.name.replace(/\s+/g, '_')}`] || ''}
                  onChange={(e) => handleInputChange(`mgnregsDaysReceived_${stage.name.replace(/\s+/g, '_')}`, e.target.value)}
                  placeholder="Enter number of days"
                  className="w-40 px-3 py-2 text-sm border border-gray-300 rounded-md"
                />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
})()}

{/* Source of Financing - For all stages */}
        <div data-field="financingSource">
          <div className="flex flex-col lg:flex-row lg:items-start gap-4">
            <label className="text-sm font-medium text-gray-700">
              Source of financing for houseowner share * 
            </label>
            <div className="flex flex-wrap gap-4">
              {financingSources.map(source => (
                <label key={source} className="flex items-center">
                  <input
                    type="checkbox"
                    value={source.toLowerCase()}
                    checked={formData.financingSource.includes(source.toLowerCase())}
                    onChange={(e) => {
                      const value = e.target.value;
                      const currentSources = [...formData.financingSource];
                      
                      if (e.target.checked) {
                        currentSources.push(value);
                      } else {
                        const index = currentSources.indexOf(value);
                        if (index > -1) {
                          currentSources.splice(index, 1);
                        }
                        if (value === 'others') {
                          handleInputChange('otherFinancingSource', '');
                        }
                      }
                      
                      handleInputChange('financingSource', currentSources);
                      setFieldErrors(prev => {
                        const newErrors = { ...prev };
                        delete newErrors.financingSource;
                        return newErrors;
                      });
                    }}
                    className="mr-2"
                  />
                  {source}
                </label>
              ))}
            </div>
          </div>
          {fieldErrors.financingSource && (
            <p className="text-red-600 text-sm mt-2">{fieldErrors.financingSource}</p>
          )}

          {/* Other Financing Source text input */}
          {formData.financingSource.includes('others') && (
            <div className="mt-2" data-field="otherFinancingSource">
              <input
                type="text"
                value={formData.otherFinancingSource}
                onChange={(e) => {
                  handleInputChange('otherFinancingSource', e.target.value);
                  setFieldErrors(prev => {
                    const newErrors = { ...prev };
                    delete newErrors.otherFinancingSource;
                    return newErrors;
                  });
                }}
                placeholder="Specify other financing source..."
                maxLength={100}
                className={`w-full sm:w-80 px-3 py-2 text-sm border rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500 ${
                  fieldErrors.otherFinancingSource ? 'border-red-500' : 'border-gray-300'
                }`}
              />
              {fieldErrors.otherFinancingSource && (
                <p className="text-red-600 text-xs mt-2">{fieldErrors.otherFinancingSource}</p>
              )}
            </div>
          )}
        </div>
  

        {/* Any Other Help Needed - For all stages */}
        <div>
          <label className="text-sm font-medium text-gray-700 mb-2 block">
            Any other help needed for houseowner?
          </label>
          <textarea
            value={formData.helpNeeded}
            onChange={(e) => handleInputChange('helpNeeded', e.target.value)}
            placeholder="Enter any other help needed..."
            maxLength={500}
            rows={3}
            className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
          />
          <p className="text-xs text-gray-500 mt-1">
            {formData.helpNeeded.length}/500 characters
          </p>
        </div>

      </div>
    )}
  </>
)}
</div>
{/* Photo Documentation */}
          <div className="bg-white rounded-lg shadow-sm border p-6" data-field="photos">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Photo Documentation</h2>
            <PhotoCapture 
              onPhotosChange={(photos) => {
                handlePhotoChange(photos);
                setFieldErrors(prev => {
                  const newErrors = { ...prev };
                  delete newErrors.photos;
                  return newErrors;
                });
              }}
              required={true}
              resetTrigger={resetPhotoTrigger}
              projectId={houseData?.id}
              initialPhotos={photoData}
            />
            {fieldErrors.photos && (
              <p className="text-red-600 text-sm mt-2">{fieldErrors.photos}</p>
            )}
          </div>

          {/* Additional Information */}
          <div className="bg-white rounded-lg shadow-sm border p-6" data-field="additionalRemarks">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">Additional Information</h2>
            
            <div>
              <label className="text-sm font-medium text-gray-700 mb-2 block">
                Additional Remarks *
              </label>
              <textarea
                value={formData.additionalRemarks}
                onChange={(e) => handleInputChange('additionalRemarks', e.target.value)}
                placeholder="Enter any additional observations or remarks..."
                maxLength={500}
                rows={3}
                className="w-full px-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              />
              <p className="text-xs text-gray-500 mt-1">
                {formData.additionalRemarks.length}/500 characters
              </p>
              {fieldErrors.additionalRemarks && (
                <p className="text-red-600 text-sm mt-2">{fieldErrors.additionalRemarks}</p>
              )}
            </div>
          </div>

              {/* Submit Actions */}
<div className="bg-white rounded-lg shadow-sm border p-6">
  <div className="flex flex-col sm:flex-row gap-3 sm:justify-end">

    {/* SAVE DRAFT */}
    <button
      type="button"
      onClick={handleSaveDraft}
      disabled={savingDraft || submitting || !houseData}
      className={`inline-flex items-center px-6 py-2 text-sm rounded-md font-medium ${
        houseData && !savingDraft && !submitting
          ? 'bg-gray-600 hover:bg-gray-700 text-white'
          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
      }`}
    >
      {savingDraft ? 'Saving Draft...' : draftInspectionId ? 'Update Draft' : 'Save Draft'}
    </button>

    {/* FINAL SUBMIT */}
    <button
      type="button"
      onClick={handleSubmit}
      disabled={submitting || savingDraft || !houseData}
      className={`inline-flex items-center px-6 py-2 text-sm rounded-md font-medium ${
        houseData && !submitting && !savingDraft
          ? 'bg-blue-600 hover:bg-blue-700 text-white'
          : 'bg-gray-300 text-gray-500 cursor-not-allowed'
      }`}
    >
      <CheckCircle className="w-4 h-4 mr-2" />
      {submitting ? 'Submitting...' : draftInspectionId ? 'Complete & Submit Draft' : 'Submit Inspection'}
    </button>

  </div>
</div>
        </div>
      </div>
    </div>
  );
};

export default InspectionForm;